import React from "react";
import { TextMonoToken } from "../text"

const TextMonoTokenTemplate = text => {
    return (<TextMonoToken>{text}</TextMonoToken>);
}

export { TextMonoTokenTemplate }